import React from 'react';
import { Search, Menu } from 'lucide-react';
import { Button } from '../ui/Button';
import { ThemeToggle } from '../ui/ThemeToggle';
import { Avatar, AvatarFallback, AvatarImage } from '../ui/Avatar';
import { NotificationsPopover } from './NotificationsPopover';
interface HeaderProps {
  onOpenCommand?: () => void;
  onOpenSidebar?: () => void;
}
export function Header({
  onOpenCommand,
  onOpenSidebar
}: HeaderProps) {
  return <header className="flex h-16 shrink-0 items-center gap-x-2 sm:gap-x-4 border-b border-border bg-background px-4 sm:px-6" data-id="element-176">
      {/* Mobile hamburger */}
      <Button variant="ghost" size="icon" className="lg:hidden -ml-2 shrink-0" onClick={onOpenSidebar} aria-label="Abrir menu" data-id="element-177">
        <Menu className="h-5 w-5" data-id="element-178" />
      </Button>

      {/* Search */}
      <div className="flex flex-1 min-w-0" data-id="element-179">
        <Button variant="outline" className="relative w-full max-w-md justify-start text-sm text-muted-foreground bg-muted/50 hover:bg-muted border-border/50" onClick={onOpenCommand} data-id="element-180">
          <Search className="mr-2 h-4 w-4 shrink-0" data-id="element-181" />
          <span className="truncate hidden sm:inline" data-id="element-182">
            Buscar OS, placa, cliente...
          </span>
          <span className="truncate sm:hidden" data-id="element-183">Buscar...</span>
          <kbd className="pointer-events-none absolute right-2 top-1/2 -translate-y-1/2 hidden h-5 select-none items-center gap-1 rounded border bg-background px-1.5 font-mono text-[10px] font-medium opacity-100 sm:flex" data-id="element-184">
            <span className="text-xs" data-id="element-185">⌘</span>K
          </kbd>
        </Button>
      </div>

      {/* Right cluster */}
      <div className="flex items-center gap-x-1 sm:gap-x-2 lg:gap-x-4 shrink-0" data-id="element-186">
        <ThemeToggle data-id="element-187" />
        <NotificationsPopover data-id="element-188" />
        <div className="hidden lg:block lg:h-6 lg:w-px lg:bg-border" aria-hidden="true" data-id="element-189" />
        <Avatar className="h-8 w-8 cursor-pointer" data-id="element-190">
          <AvatarImage src="https://api.dicebear.com/7.x/avataaars/svg?seed=Admin" alt="Admin" data-id="element-191" />
          <AvatarFallback data-id="element-192">AD</AvatarFallback>
        </Avatar>
      </div>
    </header>;
}